import { render } from "./foliodocumento.vue?vue&type=template&id=ba972cde"
import script from "./foliodocumento.vue?vue&type=script&lang=js"
export * from "./foliodocumento.vue?vue&type=script&lang=js"

import "./foliodocumento.vue?vue&type=style&index=0&id=ba972cde&lang=css"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__